import { html } from "lit-html"
import { virtual } from "haunted"
import { ROLE_ICON_MAP } from "../constants"
import { parseDate } from "../utils"
import markdown from "../utils/markdown"

const NOTES = "Notes"
const TWEETING = "Live-tweeting"
const GOOGLE_DRIVE = "Google Drive"
const TWITTER = "Twitter thread"
const BLUESKY = "Bluesky thread"

const RoleDocLinks = ({
  roles,
  url: assignmentUrl,
  summary: assignmentSummary,
}) => {
  const mainCategoryDocMap = {
    [NOTES]: [GOOGLE_DRIVE],
    [TWEETING]: [TWITTER, BLUESKY],
  }
  let roleDict = {}

  roles.forEach(({ category, label, summary, documents }) => {
    const catDocs = documents.filter((doc) =>
      mainCategoryDocMap[category].includes(doc.category)
    )
    if (roleDict[category] || catDocs.length == 0) {
      const oldSummary = roleDict[category]?.summary || ``
      roleDict[category] = {
        category,
        label,
        url: assignmentUrl,
        summary: summary.length > oldSummary.length ? summary : oldSummary,
      }
    } else {
      roleDict[category] = {
        category,
        label,
        url: catDocs[0].reporting_url,
        summary,
      }
    }
  })
  const roleData = Object.values(roleDict).sort((a, b) => {
    // Map category of roles to value: 1 for Notes, 0 for Live-tweeting, -1 for other categories
    const mainCategories = [TWEETING, NOTES]
    const aIndex = mainCategories.indexOf(a.category)
    const bIndex = mainCategories.indexOf(b.category)
    return bIndex - aIndex || a.category.localeCompare(b.category)
  })
  const teaser = (
    roleData.reduce(
      (currentTeaser, role) => currentTeaser || role.summary,
      ``
    ) || assignmentSummary
  ).replace(/[\n\r]/g, ` `)

  return html`
    <div class="flex my-5">
      ${roleData.map(
        ({ category, url, label }) =>
          html`<a class="role-icon-link mr-2 ${category}" href=${url} target="${
            url.startsWith("/") ? "" : "_blank"
          }" aria-label="${label}">
            <i
              class=${
                category in ROLE_ICON_MAP
                  ? ROLE_ICON_MAP[category]
                  : "fas fa-pen-alt"
              }
            >
            </i>
          </span>
          <span aria-hidden="true" class="icon-tooltip">${label}</span>
        </a>`
      )}
    </div>
    <div class="clamp-lines-3">${teaser ? markdown(teaser) : ``}</div>
  `
}

const ReportingRow = virtual(
  ({ name, url, start_date, tags, agency, summary, roles }) => {
    const start = parseDate(start_date)
    const startDate = start.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
      year: "numeric",
    })
    const primaryTags = tags.filter((tag) => !("primary" in tag) || tag.primary)

    return html`
      <div
        class="reporting min-h-13 max-w-570 flex flex-col p-3 py-6 border-b-px border-gray-border mx-6"
      >
        <div
          class="flex flex-row items-center justify-start flex-wrap mb-6 text-sm"
        >
          ${primaryTags.map(
            ({ color, name }, idx) =>
              html`<span
                class="tag py-3 px-5 mb-1 bg-tag-bg-${color.toLowerCase()} text-tag-text-${color.toLowerCase()} ${idx ===
                primaryTags.length - 1
                  ? `mr-4`
                  : `mr-1`}"
                >${name}</span
              >`
          )}
          <span>${startDate}</span>
        </div>
        <h3 class="text-xl line-height-reporting">
          ${agency ? html`<span>${agency.name}</span>` : ``}
          <a href=${url}>${name}</a>
        </h3>
        ${RoleDocLinks({ roles, url, summary })}
        <a href=${url}>View details</a>
      </div>
    `
  }
)

export default ReportingRow
